import React, { Fragment, useState } from 'react';
import GenericFilterParamContainer from './GenericFilterParamContainer';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { getInt } from 'utils/functions';
import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import { withAreaGetter } from 'providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { ADMIN_GENERIC_FILTER_PARAMS_READ } from 'constants/rightsCodes';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = props => {
  const historyContext = useHistoryWithContext();
  const [title, setTitle] = useState('');
  const { getElemByAreaKey } = props;
  const id = props.match.params.id && getInt(props.match.params.id);

  const onClickClose = () => {
    historyContext.push(`/genericFilterParams`);
  };

  const onChangeGenericParamTitle = genericParamTitle => {
    setTitle(genericParamTitle);
  };

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header title={title} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_GENERIC_FILTER_PARAMS_READ}>
        <GenericFilterParamContainer paramId={id} onChangeGenericParamTitle={onChangeGenericParamTitle} />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  match: PropTypes.object.isRequired,
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(withRouter(Route));
